export enum StreetType {
    Street,
    Road,
    Boulevard,
    Square,
    Close,
    Alley,
    Lane,
}
